/**
 * Shipping Page
 *
 * Staff workflow page for managing orders ready to ship.
 */

import WorkflowPage from './WorkflowPage';
import type { WorkflowStage } from '../types';

const SHIPPING_STAGES: WorkflowStage[] = [
  'READY_TO_SHIP',
  'SHIPPED',
  'COMPLETE',
  'ARCHIVED',
];

export default function Shipping() {
  return (
    <WorkflowPage
      title="Shipping"
      stages={SHIPPING_STAGES}
      defaultStage="READY_TO_SHIP"
      emptyMessage="No orders ready to ship"
    />
  );
}
